import React from 'react'
import { styled } from '@mui/material/styles'
import { useDispatch, useSelector } from 'react-redux'
import { Box, IconButton, Switch } from '@mui/material'
import LockOpen from '@mui/icons-material/LockOpen'
import EditIcon from '@mui/icons-material/Edit'

import { tableActionsStyles } from './table-actions.styles'
//import { MarketerEdit } from '../dialog'
import { useModalContext } from '../../../../ui'
import { editManager } from '../../slices'
import { toggleManagerActive } from '../../slices'
import { EditManager } from '../edit-user/edit-user.component'
import { AddPermissions } from '../add-permissions/add-permissions'

const PREFIX = 'TableActions'

const classes = {
  root: `${PREFIX}-root`,
  switchBase: `${PREFIX}-switchBase`,
  track: `${PREFIX}-track`,
  checked: `${PREFIX}-checked`,
}

const StyledSwitch = styled(Switch)(({ theme }) => ({
  [`& .${classes.root}`]: {
    marginRight: 10,
  },

  [`& .${classes.switchBase}`]: {
    '&$checked': {
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },

  [`& .${classes.track}`]: {
    backgroundColor: theme.palette.grey[500],
  },

  [`& .${classes.checked}`]: {},
}))

export const TableActions = (props) => {
  const {
    actions: { open },
  } = useModalContext()

  const rowData = props.row?.original || props.rowData

  if (!rowData || !rowData.id) {
    return null
  }

  const managerId = rowData['id']

  const handleGoToPermissions = () =>
    open({
      Component: AddPermissions,
      data: { props: { ...props, rowData }, editManager },
      maxWidth: 'md',
    })

  const handleEditManager = () =>
    open({
      Component: EditManager,
      data: { managerId, editManager, props: { ...props, rowData } },
      maxWidth: 'md',
    })

  const tariffButtons = {
    edit: {
      onClick: handleEditManager,
      icon: <EditIcon />,
    },
    permissions: {
      onClick: handleGoToPermissions,
      icon: <LockOpen />,
    },
  }

  const availableActions = ['permissions', 'edit']

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-around',
      }}
      p={0}
    >
      {availableActions.map((action) => {
        return (
          <IconButton
            sx={{
              borderRadius: '100%',
              border: '1px solid #333',
              height: '1.7em',
              width: '1.7em',
            }}
            key={action}
            size="small"
            onClick={tariffButtons[action].onClick}
          >
            {tariffButtons[action].icon}
          </IconButton>
        )
      })}
    </Box>
  )
}

export const TableActive = ({ ...props }) => {
  const dispatch = useDispatch()
  const global = useSelector((state) => state.global)
  const managers = useSelector((state) => state.managers.data)

  // Obtener rowData desde props.row.original (estructura MUI Material React Table)
  const rowData = props.row?.original || props.rowData

  if (!rowData || !rowData.id) {
    return null
  }

  const switchDisabled = '' + rowData.id === global.user_id
  const marketerActiveState = rowData['activo']

  const handleToggleState = () => dispatch(toggleManagerActive(rowData, managers))
  return (
    <Switch
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        track: classes.track,
        checked: classes.checked,
      }}
      checked={marketerActiveState}
      onClick={handleToggleState}
      disabled={switchDisabled}
    />
  )
}
